export default __webpack_public_path__ + "static/media/cancer6.b8c691da.jpg";